import { render } from "./UserDataForm.vue?vue&type=template&id=3669c55e&scoped=true&ts=true"
import script from "./UserDataForm.vue?vue&type=script&lang=ts"
export * from "./UserDataForm.vue?vue&type=script&lang=ts"

import "./UserDataForm.vue?vue&type=style&index=0&id=3669c55e&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src93515913/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3669c55e"]])

export default __exports__